import { useAppSelector } from "hooks/storeHooks"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { IntegrationType } from "types"
import { Box, Typography } from "@strapi/design-system"
import { AddProductCard } from "./AddProductCard"

interface AddProductStepOneProps {
  handleGoToStepTwo: (type?: string) => void
}

export const AddProductStepOne: React.FC<AddProductStepOneProps> = ({ handleGoToStepTwo }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const userType = useAppSelector((state) => state.user.userInfo.integrationType)

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "start",
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          width: "100%",
        }}
      >
        <Typography
          variant="beta"
          style={{ textAlign: "center", marginBottom: "10px", marginTop: "20px" }}
        >
          {t("addProductStepOne.title")}
        </Typography>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 24,
            alightItems: "center",
            justifyContent: "center",
          }}
        >
          {userType === IntegrationType.COMMON ? (
            <AddProductCard
              title={t("addProductStepOne.bulkTitle")}
              description={t("addProductStepOne.bulkDescription")}
              onClick={() => handleGoToStepTwo("bulk")}
            />
          ) : null}

          {userType !== IntegrationType.COMMON ? (
            <AddProductCard
              title={t("addProductStepOne.storeTitle")}
              description={t("addProductStepOne.storeDescription")}
              onClick={() => handleGoToStepTwo("from-store")}
            />
          ) : (
            <AddProductCard
              title={t("addProductStepOne.manualTitle")}
              description={t("addProductStepOne.manualDescription")}
              onClick={() => navigate("/products/add")}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}
